// ---------------------------------------

// 公共
import { common } from './system/platform/common/en'
// 核心
import { kernel } from './system/platform/kernel/en'


// ---------------------------------------
// 模块

export default {
  // 公共
  common: {
    ...common,
  },

  // 核心
  kernel: {
    ...kernel,
  },

  // ------------------------------------

}
